import React, { useState, useEffect } from "react";
import { Col, Row, Dropdown, Container, Offcanvas } from "react-bootstrap";
import { NavLink } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Connectwallet from "../Modals/Connectwallet";
import { useHistory } from "react-router-dom";
import { removeAuthToken } from "../lib/localStorage";
import nav from "../config/routes";
import { isEmpty } from "../lib/isEmpty";
import { SwitchChainS, setChainId } from "../Hooks/useWeb3";
import { CHAINS } from "../config/env";
import { NETWORK_SWITCH } from "../constant";

function Header({ title }) {
  const history = useHistory();

  const logout = async () => {
    try {
      removeAuthToken();
      localStorage.removeItem('adminWalletAddress')
      localStorage.removeItem('referrerFeeAccount')
      history.push("/");

    } catch (err) {
      console.log(err, "err_logout");
    }
  };


  const walletLogout = async () => {
    try {
      localStorage.removeItem('adminWalletAddress')
      localStorage.removeItem('referrerFeeAccount')

      dispatch({
        type: "SET_ADMINWALLET",
        payload: '',
      });

      setDrop(false);
    } catch (err) {
      console.log(err, "err_logout");
    }
  };


  let { restriction } = useSelector((state) => state.isRun);
  let { adminWalletAddress } = useSelector((state) => state.adminAddress);

  const dispatch = useDispatch();
  const switcher = useSelector((state) => state.switcher);
  const [mobSearch, setMobSearch] = useState(false);

  const [network, setNetwork] = useState(CHAINS[localStorage.getItem('CHAIN')]?.NAME)


  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  // connect wallet modal

  const [showWallet, setShowWallet] = useState(false);
  const [accountInfo, setAccountInfo] = useState("");

  const handleCloseWallet = () => setShowWallet(false);
  const handleShowWallet = () => setShowWallet(true);

  const setSwitcher = (val) => {
    dispatch({
      type: "switching",
      value: { switcher: val },
    });
  };


  useEffect(() => {
    setAccountInfo(adminWalletAddress)
  }, [adminWalletAddress, showWallet]);


  const [drop, setDrop] = useState(false);

  return (
    <>
      <div className="header px-lg-2">
        {/* {mobSearch && 
    <div className='mob_searchbar_holder p-3 d-flex justify-content-start align-items-center gap-3'>
                            <input type='text' placeholder='Search' className='mob_searchbar_inp flex-grow-1' />
                            <i class="fa-solid fa-xmark" onClick={() => setMobSearch(false)}  />
                    </div>} */}
        <Row className="align-items-center h-100 flex-grow-1 mt-4">
          <Col xl={6} lg={4} md={4} xs={7} className="d-flex gap-3">
            <p className="header_title d-block d-xl-none" onClick={handleShow}>
              <i class="fa-solid fa-bars" />
            </p>
            <p className="header_title">{title}</p>
          </Col>
          <Col
            xl={6}
            lg={8}
            md={8}
            xs={5}
            className="d-flex justify-content-end align-items-center gap-3 header-ryt-sec"
          >
            {/* <div className='header_searchbar_holder flex-grow-1 d-none d-md-block'>
        <div className='header_searchbar rounded-5 d-flex justify-content-start align-items-center gap-2 px-3 py-2'>
                        <img src={require('../assets/images/searchglass.svg').default} className='img-fluid' />
                        <input type='text' className='header_searchbar_input flex-grow-1' placeholder='Search' />
                    </div>
                    </div> */}
            {/* mobile searchbar */}
            {/* <img src={require('../assets/images/searchglass.svg').default} className='img-fluid mob_searchglass d-block d-md-none' onClick={() => setMobSearch(true)} /> */}

            {/* end of mobile searchbar */}
            {/* <div className='header_switch_holder d-none d-sm-block'>
                    <div className='header_dragger p-2 rounded-5 position-relative d-flex justify-content-center align-items-center w-100' >
                        <img src={switcher ? require('../assets/images/bitcoin.svg').default : require('../assets/images/thunder.svg').default} className={`img-fluid header_switchThunder ${switcher ? 'header_thunderRight' : 'header_thunderLeft'}`} onClick={()=> setSwitcher(!switcher)} />
                        <p className={`header_switchHint ${switcher ? 'me-3' : 'ms-3'} `}>{switcher ? 'Switch to BTC' : 'Switch to LN'}</p>
                    </div>
                    </div> */}

            <div className="header_profileImg_holder">
              <Dropdown className="header_profile_drop network_drop" drop="down">
                <Dropdown.Toggle id="dropdown-basic">{CHAINS[0].NAME ? CHAINS[0].NAME : "Select Network"}</Dropdown.Toggle>

                <Dropdown.Menu>
                  {/* <Dropdown.Item
                    // onClick={() => localStorage.setItem("CHAIN", 0)}
                    onClick={async () => {
                      let SwitchRes = await SwitchChainS(0);
                      if (SwitchRes) {
                        localStorage.setItem("CHAIN", 0)
                        setNetwork(CHAINS[0].NAME)
                        setChainId('0');
                        dispatch({
                          type: NETWORK_SWITCH,
                          payload: '0',
                        });
                      }
                    }}>
                    BSC
                  </Dropdown.Item> */}
                  {/* <Dropdown.Item
                    onClick={async () => {
                      localStorage.setItem("CHAIN", 0)
                      let SwitchRes = await SwitchChainS(1);
                      if (SwitchRes) {
                        setChainId('0');
                        setNetwork(CHAINS[0].NAME)
                        dispatch({
                          type: NETWORK_SWITCH,
                          payload: '1',
                        });
                      }
                    }}>
                    Polygon
                  </Dropdown.Item> */}
                </Dropdown.Menu>
              </Dropdown>
            </div>







            {accountInfo == "" || accountInfo == null ? (

              <button
                className="orange_primary_btn header__cnctWalletBtn"
                onClick={handleShowWallet}
              >
                Connect Wallet
              </button>
            ) : (
              <>
                <Dropdown className="walletdrop">
                  <Dropdown.Toggle className="orange_primary_btn header__cnctWalletBtn">
                    {`${accountInfo.substring(0, 6)}...${accountInfo.substring(
                      36,
                      42
                    )}`}
                  </Dropdown.Toggle>
                  <Dropdown.Menu>
                    <button className="orange_primary_btn header__cnctWalletBtn w-100" onClick={walletLogout}>Logout</button>
                  </Dropdown.Menu>
                </Dropdown>
                {/* <Dropdown className={`walletdrop ${drop && "show"}`} onMouseOver={() => setDrop(true)} onMouseLeave={() => setDrop(false)}>
                  <Dropdown.Toggle className={`orange_primary_btn header__cnctWalletBtn ${drop && "show"}`}>
                    {`${accountInfo.substring(0, 6)}...${accountInfo.substring(
                      36,
                      42
                    )}`}
                  </Dropdown.Toggle>
                  <Dropdown.Menu className={`${drop && "show"}`} show={drop}>
                    <button className="orange_primary_btn header__cnctWalletBtn w-100" onClick={walletLogout}>Logout</button>
                  </Dropdown.Menu>
                </Dropdown> */}

                {/* <button
                  className="orange_primary_btn header__cnctWalletBtn"
                  onClick={walletLogout}
                >
                  {`${accountInfo.substring(0, 6)}...${accountInfo.substring(
                    36,
                    42
                  )}`}
                </button> */}
              </>
            )}


            {/* <div className='header_profileImg_holder'>
                    <Dropdown className='header_profile_drop' drop='down'>
      <Dropdown.Toggle  id="dropdown-basic">
                    <img src={require('../assets/images/profile.png')} className='img-fluid header_profileImg rounded-5' />
      </Dropdown.Toggle>

      <Dropdown.Menu>
        <Dropdown.Item className='rounded-2' href='/profile'>Profile</Dropdown.Item>
        <Dropdown.Item className='rounded-2' href='/resetPassord'>Reset Password</Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
                    </div> */}
          </Col>
        </Row>
      </div>

      {/* offcanva content */}
      <Offcanvas
        show={show}
        onHide={handleClose}
        backdrop="static"
        className="header_canvas"
      >
        <Offcanvas.Body>
          <div className="header_canva_header pb-3 d-flex justify-content-between align-items-center">
            <NavLink to="/dashboard">
              <img
                src={require("../assets/images/logo.png")}
                className="img-fluid"
              />
            </NavLink>
            <button
              className="cmn_modal_closer rounded-5"
              onClick={handleClose}
            >
              <i class="fa-solid fa-xmark" />
            </button>
          </div>
          <ul className="pt-4 sidebar__scrollUl">
            {nav && nav.length > 0
              ? nav.map((item) => {
                // let Restriction = restriction
                if (
                  restriction?.length > 0 &&
                  restriction?.includes(item.path)
                ) {
                  return (
                    <li className="rounded-end-5 mb-3">
                      <NavLink
                        to={item.path}
                        className="sidebar_links d-flex gap-3 justify-content-start align-items-center p-2 ps-4"
                      >
                        <img
                          src={item.image}
                          className="img-fluid sidebar_linkImg"
                        />
                        <p className="sidebar_link_hint">{item.name}</p>
                      </NavLink>
                    </li>
                  );
                } else if (isEmpty(restriction)) {
                  return (
                    <li className="rounded-end-5 mb-3">
                      <NavLink
                        to={item.path}
                        className="sidebar_links d-flex gap-3 justify-content-start align-items-center p-2 ps-4"
                      >
                        <img
                          src={item.image}
                          className="img-fluid sidebar_linkImg"
                        />
                        <p className="sidebar_link_hint">{item.name}</p>
                      </NavLink>
                    </li>
                  );
                }
              })
              : ""}
            <li
              className="rounded-end-5 d-flex justify-content-start align-items-center gap-3 mb-3 p-2 ps-4"
              onClick={() => logout()}
            >
              {/* <NavLink className="sidebar_links d-flex gap-3 justify-content-start align-items-center p-2 ps-4"> */}
              <img
                src={require("../assets/images/logout.svg").default}
                className="img-fluid sidebar_linkImg"
              />
              <p className="sidebar_link_hint">Logout</p>
              {/* </NavLink> */}
            </li>
          </ul>

          {/* <div className='header_switch_holder d-md-none ps-4'>
                    <div className='header_dragger p-2 rounded-5 position-relative d-flex justify-content-center align-items-center w-100' >
                        <img src={switcher ? require('../assets/images/bitcoin.svg').default : require('../assets/images/thunder.svg').default} className={`img-fluid header_switchThunder ${switcher ? 'header_thunderRight' : 'header_thunderLeft'}`} onClick={()=> {setSwitcher(!switcher);handleClose()}} />
                        <p className={`header_switchHint ${switcher ? 'me-3' : 'ms-3'} `}>{switcher ? 'Switch to BTC' : 'Switch to LN'}</p>
                    </div>
                    </div> */}
        </Offcanvas.Body>
      </Offcanvas>
      {/* end of offcanva content */}

      {/* modal */}
      <Connectwallet show={showWallet} handleClose={handleCloseWallet} />
      {/* end of modal */}
    </>
  );
}

export default Header;
